export default __webpack_public_path__ + "static/media/cronos.56d8f064.svg";